import { Box } from "@mui/material";
import AdminJigsawPlay from "./AdminJigsawPlay";

export default function AdminJigsawPlayMain() {
    return (
        <Box>
            <AdminJigsawPlay />
        </Box>
    );
}
